<template>
  <base-nav class="navbar-top navbar-dark" id="navbar-main" :show-toggle-button="false" expand>

    <form class="navbar-search navbar-search-dark form-inline mr-3 d-none d-md-flex ml-lg-auto">
      <div class="form-group mb-0">
        <!--
        <base-input
          placeholder="Search"
          class="input-group-alternative"
          alternative=""
          addon-right-icon="fas fa-search"
        >
        </base-input>
        -->
      </div>
    </form>

    <ul class="navbar-nav align-items-center d-none d-md-flex">
      <li class="nav-item dropdown">
        <div class="media align-items-center nav-link pr-0 dropdown" data-toggle="dropdown" data-display="static" aria-expanded="false">
          <div class="media-body ml-2 d-none d-lg-block">
            <span class="avatar avatar-sm rounded-circle">
              <i class="bi bi-person-circle fa-2x"></i>
              <!--
                <img
                  alt="Image placeholder"
                  src="static/img/theme/team-4-800x800.jpg"
                /> TBD: Set image???-->
            </span>
            <span class="mb-0 text-sm font-weight-bold text-white">{{ username }}</span>
          </div>
        </div>
        <div class="dropdown-menu dropdown-menu-lg-right">
          <div class="dropdown-header noti-title">
            <h6 class="text-overflow m-0">{{$t('dashboard_layout.userOverlayBoxTitle',{name: username})}}</h6>
          </div>
          <router-link to="/account" class="dropdown-item">
            <i class="ni ni-single-02"></i>
            <span>{{$t('dashboard_layout.profile')}}</span>
          </router-link>
          <!--<router-link to="/profile" class="dropdown-item">
            <i class="ni ni-settings-gear-65"></i>
            <span>Settings</span>
          </router-link>
          <router-link to="/profile" class="dropdown-item">
            <i class="ni ni-calendar-grid-58"></i>
            <span>Activity</span>
          </router-link>
          <router-link to="/profile" class="dropdown-item">
            <i class="ni ni-support-16"></i>
            <span>Support</span>
          </router-link> -->
          <div class="dropdown-divider"></div>
          <a v-on:click="logout" class="dropdown-item">
            <i class="ni ni-user-run"></i>
            <span>{{$t('dashboard_layout.logOut')}}</span>
          </a>

        </div>
      </li>
    </ul>
  </base-nav>
</template>
<script>
import i18n from '@/contents/contents'

export default {
  data() {
    return {
      activeNotifications: false,
      showMenu: false,
      searchQuery: "",
      username: ""
    };
  },
  mounted() {
    var user = JSON.parse(localStorage.getItem("user"));
    this.username = user.user.name;

    var landlord = JSON.parse(localStorage.getItem("landlord"));
    i18n.global.locale = landlord.contact_details.language;

  },
  methods: {
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    toggleMenu() {
      this.showMenu = !this.showMenu;
    },
    logout() {
      localStorage.removeItem('user');

      this.$router.push('/login')
    }
  },
};
</script>
